export { default as SerpStoreChangeSlot } from './SerpStoreChangeSlot';
